﻿module.exports = {
    "id": "tc",
    "label": "Traditional Chinese",
    "rtl": false,

    "translations": {
        "INVALID_LINK_TITLE":"鏈接無效",
        "INVALID_LINK_TEXT":"請點擊電郵內的取消訂閱鏈接,將您的電郵從我們的列表中移除。",
        "UNSUBSCRIBE_ARE_YOU_SURE":"您確定要把電郵從我們的列表中移除？",
        "UNSUBSCRIBE_CLICK_CONFIRM":"點擊\取消訂閱\"按鈕以示確認。",
        "YOU_HAVE_BEEN_UNSUBSCRIBED":"您已<b>取消訂閱</b>。",
        "UNSUBSCRIBED_IN_ERROR":"如果您誤點了取消訂閱，請點擊 <a href='/resubscribe' class='resubscribe'>重新訂閱</a>。",
        "CANCELLED_STILL_SUBSCRIBED":"<b>已取消。</b> 您依舊<b>訂閱</b>我們的電郵。",
        "THANK_YOU_FOR_CONTINUING":"感謝您繼續參與我們的調查。",
        "EMAIL_ALREADY_UNSUBSCRIBED":"該郵箱已<b>取消訂閱</b>。",
        "CLICK_RESUBSCRIBE_TO_REJOIN":"點擊下方的\重新訂閱\"按鈕再次加到我們的電郵列表。",
        "YOU_HAVE_BEEN_RESUBSCRIBED":"您已<b>重新訂閱</b>到我們的電郵列表。",
        "YOU_ARE_ALREADY_SUBSCRIBED":"您已<b>訂閱</b>我們的電郵列表。",
        "THANK_YOU_FOR_PARTICIPATING":"感謝您參與我們的調查。",
        "CHECKING":"核對中…",
        "UNSUBSCRIBE":"取消訂閱",
        "RESUBSCRIBE":"重新訂閱",
        "EMAIL":"電郵",
        "CANCEL":"取消"

    }
};

